export default __webpack_public_path__ + "static/media/skill.480e91cd.svg";